import { useField } from 'formik';
import { FC, useCallback } from 'react';
import PinInput from 'react-pin-field';

import styles from './PhoneCodeVerificationInput.module.scss';

interface Props {
  fieldName: string;
  resendCodeFieldName: string;
  verificationLength: number /** Expected size of the verification code */;
  isSubmitting: boolean;
}

export const PhoneCodeVerificationInput: FC<Props> = ({
  fieldName,
  resendCodeFieldName,
  isSubmitting,
  verificationLength,
}) => {
  const [_field, _meta, helpers] = useField<string>(fieldName);
  const [fieldResendCode] = useField<boolean>(resendCodeFieldName);

  const handleChange = useCallback(
    (value: string) => {
      helpers.setTouched(true);
      helpers.setValue(value);
    },
    [helpers.setValue],
  );

  return (
    <div className={styles.verificationTokenFormContainer}>
      <PinInput
        name="verificationCode"
        validate={/^\d$/}
        autoFocus
        length={verificationLength}
        onChange={handleChange}
        disabled={fieldResendCode.value || isSubmitting}
        data-testid="signup-verification-code"
      />
    </div>
  );
};
